import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPill = (props) => /* @__PURE__ */ _jsx("svg", {
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M12.647 5.427a4.872 4.872 0 1 1 6.89 6.89l-4.007 4.006-.005-.006-3.209 3.209a4.873 4.873 0 1 1-6.889-6.89L9.433 8.63l.006.006 3.208-3.208Zm2.079 10.092-5.293-5.293-3.208 3.208a3.742 3.742 0 1 0 5.293 5.293l3.208-3.208Z",
		fill: "currentColor"
	})
});
export default SvgPill;
